<div class="lum-modal invoice-shipping-rate-dialog__modal-wrapper">
  <div
    class="overlay"
    lumAppLoader
    [loading]="(loading$ | async) || false"
    [classes]="'loading blur'"
  ></div>
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Shipping Rate</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div
      *ngIf="invalidLocationAddress; else shippingRateForm"
      class="lum-alert lum-alert--error mb-5"
    >
      Please update <b>"{{ warehouse.location_name }}"</b> from the warehouse and
      use valid address details.
      <p class="mt-2">
        <a href="/locations/warehouses" target="_blank"
          >>> Go to Warehouse Settings</a
        >
      </p>
    </div>

    <ng-template #shippingRateForm>
      <mat-tab-group class="header-less-tabs" dynamicHeight #tabGroup>
        <mat-tab label="">
          <form
            [formGroup]="form"
            class="shipping-quote__wrapper flex gap-4 grow"
            (submit)="onSubmit(tabGroup)"
          >
            <div class="flex align-center gap-3">
              <div class="shipping-quote__label">Carrier</div>
              <div class="shipping-quote__input">
                <mat-select
                  formControlName="carrierCode"
                  class="lum-select"
                  (selectionChange)="onSelectCarrier($event)"
                >
                  <mat-option
                    *ngFor="let carrier of carriers"
                    [value]="carrier?.code"
                    >{{ carrier.name }}</mat-option
                  >
                </mat-select>
                <mat-error
                  *ngIf="carrierCodeControl && carrierCodeControl.invalid"
                  >{{ carrierCodeControl | validateField }}</mat-error
                >
              </div>
            </div>
            <div class="flex align-center gap-3" formGroupName="weight">
              <div class="shipping-quote__label">Weight</div>
              <div class="shipping-quote__input flex">
                <div class="flex align-center gap-1" formGroupName="pounds">
                  <div class="flex flex-column">
                    <input
                      formControlName="value"
                      type="number"
                      min="0"
                      matInput
                      class="lum-input"
                      (blur)="validateWeight('pounds.value')"
                    />
                    <mat-error
                      *ngIf="weightValueControl && weightValueControl.invalid"
                      >{{ weightValueControl | validateField }}</mat-error
                    >
                  </div>
                  <div class="flex justify-content-end">
                    <span
                      class="
                        text-underline cursor-pointer block w-25 text-purple-600 font-semi-bold
                      "
                    >
                      (LBS)
                    </span>
                  </div>
                </div>
                <div class="flex align-center gap-1" formGroupName="ounces">
                  <div class="flex flex-column">
                    <input
                      formControlName="value"
                      type="number"
                      min="0"
                      matInput
                      class="lum-input"
                      (blur)="validateWeight('ounces.value')"
                    />
                    <mat-error
                      *ngIf="weightValueControl && weightValueControl.invalid"
                      >{{ weightValueControl | validateField }}</mat-error
                    >
                  </div>
                  <div class="flex justify-content-end">
                    <span
                      class="
                        text-underline cursor-pointer block w-25 text-purple-600 font-semi-bold
                      "
                    >
                      (OZ)
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex align-center gap-3">
              <div class="shipping-quote__label">Service</div>
              <div class="shipping-quote__input">
                <mat-select formControlName="serviceCode" class="lum-select">
                  <mat-option
                    *ngFor="let service of services"
                    [value]="service?.code"
                    >{{ service.name }}</mat-option
                  >
                </mat-select>
              </div>
            </div>
            <div class="flex align-center gap-3">
              <div class="shipping-quote__label">Package</div>
              <div class="shipping-quote__input">
                <mat-select formControlName="packageCode" class="lum-select">
                  <mat-option
                    *ngFor="let package of packages"
                    [value]="package?.code"
                    >{{ package.name }}</mat-option
                  >
                </mat-select>
              </div>
            </div>
            <div class="flex align-center gap-3" formGroupName="dimensions">
              <div class="shipping-quote__label">Size</div>
              <div class="shipping-quote__input flex justify-space-between gap-7">
                <div class="flex align-center gap-1">
                  <input
                    formControlName="length"
                    type="number"
                    min="0"
                    matInput
                    class="lum-input"
                  />
                  L
                </div>
                <div class="flex align-center gap-1">
                  <input
                    formControlName="width"
                    type="number"
                    min="0"
                    matInput
                    class="lum-input"
                  />
                  W
                </div>
                <div class="flex align-center gap-1">
                  <input
                    formControlName="height"
                    type="number"
                    min="0"
                    matInput
                    class="lum-input"
                  />
                  H
                  <span
                    class="text-underline cursor-pointer text-purple-600 font-semi-bold"
                    #menuTrigger="matMenuTrigger"
                    [matMenuTriggerFor]="dimensionMenu"
                  >
                    ({{ dimensionUnit }})
                  </span>
                  <mat-menu class="lum-mat-menu" #dimensionMenu="matMenu">
                    <button
                      *ngFor="let unit of dimensionUnits"
                      mat-menu-item
                      (click)="onSetUnit('dimensions.units', unit.value)"
                    >
                      {{ unit.value }} ({{ unit.label }})
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
            <div class="flex align-center gap-3">
              <div class="shipping-quote__label">Confirmation</div>
              <div class="shipping-quote__input flex align-center gap-2">
                <mat-select formControlName="confirmation" class="lum-select">
                  <mat-option
                    *ngFor="let option of confirmationOptions"
                    [value]="option"
                    >{{ option }}</mat-option
                  >
                </mat-select>
              </div>
            </div>
            <div class="flex align-center gap-3 mt-2">
              <div class="shipping-quote__label"></div>
              <div class="shipping-quote__input">
                <mat-checkbox class="lum-checkbox" formControlName="residential"
                  >Residential</mat-checkbox
                >
              </div>
            </div>
            <div class="lum-modal__footer">
              <div class="flex ml-auto lum-modal__action">
                <button
                  type="submit"
                  class="lum-button lum-button--large gap-5"
                  [disabled]="hasInvalidInput || (loadingRates$ | async) || false"
                >
                  Next
                  <mat-progress-spinner
                    *ngIf="(loadingRates$ | async) || false"
                    class="progress-spinner"
                    diameter="13"
                    mode="indeterminate"
                  ></mat-progress-spinner>
                </button>
              </div>
            </div>
          </form>
        </mat-tab>
        <mat-tab label="">
          <div *ngIf="rates.length === 0" class="lum-alert lum-alert--error mb-5">
            No rates available.
          </div>
          <div class="lum-modal__body">
            <div class="list-scroll-container">
              <mat-list class="shipping-rates__wrapper">
                <mat-list-item
                  *ngFor="let rate of rates"
                  (click)="onSelectShippingRate(rate)"
                  class="rate-item"
                >
                  <div class="rate">
                    <div class="flex-column col-left">
                      <input
                        type="radio"
                        name="shippingrate"
                        [value]="rate.shipmentCost"
                        class="lum-radio"
                      />
                      {{ rate.serviceName }}
                    </div>
                    <div class="flex-column col-right">
                      {{ rate.shipmentCost | currency }}
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </mat-list-item>
              </mat-list>
            </div>
          </div>
          <div class="lum-modal__footer">
            <div class="flex ml-auto lum-modal__action gap-2">
              <button
                class="lum-button lum-button--large lum-button--secondary"
                (click)="onChangeTab(tabGroup, 0)"
              >
                Back
              </button>
              <button
                class="lum-button lum-button--large"
                [disabled]="rates.length === 0"
                (click)="onSetShippingRate()"
              >
                Add
              </button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-template>
  </div>
</div>
